module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"year":"Год","month":"Месяц","day":"День","hour":"Час","minute":"Минута","second":"Секунда"},"en":{"year":"Year","month":"Month","day":"Day","hour":"Hour","minute":"Minute","second":"Second"}}')
  delete Component.options._Ctor
}
